import React from 'react';
import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import clsx from 'clsx';
import {
  Button,
  Typography,
  Grid,
} from '@material-ui/core';

import useStyles from './styles';

function Header({
  className,
  supermarket,
  productDescription,
  productBrand,
  sku,
  ...rest
}) {
  const classes = useStyles();

  return (
    <Grid
      className={clsx(classes.root, className)}
      container
      justifyContent="space-between"
      spacing={3}
      {...rest}
    >
      <Grid item>
        <Typography
          variant="h3"
          color="textPrimary"
        >
          {productDescription}
        </Typography>
        <Typography
          variant="h5"
          color="textSecondary"
        >
          {supermarket} - {productBrand} - SKU: {sku}
        </Typography>
      </Grid>
      <Grid item>
        <Button
          component={RouterLink}
          to="/datos/productsnapshots"
        >
          Volver
        </Button>
      </Grid>
    </Grid>
  );
}

Header.propTypes = {
  className: PropTypes.string,
  supermarket: PropTypes.string,
  productDescription: PropTypes.string,
  productBrand: PropTypes.string,
  sku: PropTypes.string,
};

export default Header;
